define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var core = require('core');
    var _ = require('underscore');
    var BaseView = require('common/base.view');
    var StepModel = require('portlets/registration/registration.step.model');
    var Form = require('class/form.class');
    var dateMixin = require('portlets/registration/mixins/date.mixin');
    var userNameMixin = require('portlets/registration/mixins/username.mixin');
    var user = require('user');

    module.exports = BaseView.extend({

        mixins: [dateMixin, userNameMixin],

        order: 0,

        isLoading: false,

        className: 'fn-register-step portlet-registration__step',

        originalEvents: {},

        additionalEvents: {},

        data: null,

        stepModel: null,

        form: null,

        events: function() {
            return _.extend({}, BaseView.prototype.events, this.originalEvents, this.additionalEvents);
        },

        subscribe: function() {
            this.listenTo(this.model, 'change:config', this.changeConfigHandler);
            this.listenTo(core, 'registration:sendForm', () => this.form.showLoading());
            this.listenTo(core, 'registration:sendForm:done', () => this.form.hideLoading());
            this.listenTo(user, 'change:registrationInfo', this.fillUserData.bind(this));
        },

        initialize: function(options) {
            this.options = _.extend({
                template: 'step1'
            }, options);
            this.stepModel = new StepModel();
            this.data = {};
        },

        render: function() {
            var genericRules = this.stepModel.get('genericRules');
            this.$el.html(this.tmpl(this.options.template, this.config));

            this.form = new Form(this.$('form'), {
                genericRules: genericRules,
                validationConfig: this._getValidationConfig(),
                data: this._getCustomFormData(),
                isRegistrationForm: true
            });

            this.fillUserData();
            //save initial form data
            _.extend(this.data, this.form.data());

            this.form.$el.on('form:focusout.form', function() {
                this._saveData();
            }.bind(this));

            return this;
        },

        fillUserData: function() {
            var registrationInfo = user.get('registrationInfo');
            var formData = this.form.data();
            var regBuilderFormFields = this.model.get('config')?.regBuilderForm?.formFields || this.model.get('config')?.regBuilderForm?.formElements || [];

            if (!registrationInfo) {
                return;
            }

            var regBuilderBirthDateField = regBuilderFormFields.find(function(element) { return element.imsField === 'birthdate'; });

            if (regBuilderBirthDateField) {
                var birthDate = registrationInfo.birthdate.split('-');
                var day = 'day_' + regBuilderBirthDateField.name;
                var month = 'month_' + regBuilderBirthDateField.name;
                var year = 'year_' + regBuilderBirthDateField.name;

                this.form.data({
                    [day]: birthDate[2],
                    [month]: birthDate[1],
                    [year]: birthDate[0]
                });
            }

            _.each(registrationInfo, function(value, key) {
                if (key === 'playerHash') {
                    this.form.data({
                        playerHash: registrationInfo.playerHash
                    });

                    return;
                }

                var regBuilderField = regBuilderFormFields.find(function(element) { return element.imsField === key; });

                if (regBuilderField && regBuilderField.name in formData) {
                    var data = {};

                    data[regBuilderField.name] = value;
                    this.form.data(data);
                }
            }.bind(this));
        },

        _saveData: function() {
            this.data = this.form.data();
            this.model.trigger('formData:update');
        },

        validate: function() {
            var process = $.Deferred();
            this._saveData();
            this.isLoading = true;

            this.form.validate(null, this.model.get('formData'))
                .done((result) => process.resolve(result))
                .fail((error) => process.reject({
                    ...error,
                    step: this
                }))
                .always(() => {
                    this.isLoading = false;
                });

            return process;
        },

        getData: function() {
            return this.stepModel.getData(this.data);
        },

        getValidationData: function() {
            return this.getData();
        },

        /**
         * Use this method to override default validation config
         * @private
         * @return {Object}
         */
        _getValidationConfig: function() {
            return this.stepModel.getValidationConfig();
        },

        /**
         * Use this method to add custom data for form validationConfig
         * @private
         * return {Object|null}
         */
        _getCustomFormData: function() {
            var cfg = this.model.get('config');

            if (!(cfg.depositConfig || cfg.betLimits || cfg.lossLimits)) {
                return null;
            }

            var data = {};

            if (cfg.depositConfig) {
                _.extend(data, {
                    allowedLimits: cfg.limit && cfg.limit.allowedLimits,
                    predefinedType: cfg.depositConfig.predefinedType,
                    playerMustSetLimits: cfg.depositConfig.playerMustSetLimits,
                    allPeriodsRequired: cfg.depositConfig.allPeriodsRequired,
                    noLimitsAllowed: cfg.depositConfig.noLimitsAllowed,
                    UNLIMITED_AMOUNT: cfg.UNLIMITED_AMOUNT
                });
            }

            if (cfg.betLimits && cfg.betLimits.config) {
                var betConfig = cfg.betLimits.config;

                _.extend(data, {
                    betLimitsConfig: {
                        predefinedLimits: betConfig.predefinedLimits,
                        predefinedType: betConfig.predefinedType,
                        mandatory: betConfig.mandatory,
                        noLimitsAllowed: betConfig.noLimitsAllowed,
                        unlimitedAmount: betConfig.unlimitedAmount
                    }});
            }

            if (cfg.lossLimits && cfg.lossLimits.config) {
                var lossConfig = cfg.lossLimits.config;

                _.extend(data, {
                    lossLimitsConfig: {
                        predefinedLimits: lossConfig.predefinedLimits,
                        predefinedType: lossConfig.predefinedType,
                        mandatory: lossConfig.mandatory,
                        noLimitsAllowed: lossConfig.noLimitsAllowed,
                        unlimitedAmount: lossConfig.unlimitedAmount
                    }});
            }

            return data;
        },

        _clearRenderListeners: function() {
            if (this.form && typeof this.form.undelegateEvents === 'function') {
                this.form.undelegateEvents();
            }
        },

        changeConfigHandler: function() {
            this.mergeConfig();
            this._clearRenderListeners();
            this.render();
        },

        mergeConfig: function() {
            var modelConfig = this.model.get('config');

            _.extend(this.config, modelConfig);
        }
    });

});
